<template lang='pug'>
#ThemesSlideshow
 .eg-theme-agrume
  .eg-slideshow
    slide.local-eg-theme-book_cover-works(enter='flipInX' leave='hinge' :style="{ 'background-image' : 'linear-gradient(rgba(17,34,51,0.15),rgba(17,34,51,0.55)), url(\' + about_images[0] + \')' }")
      eg-transition(enter='lightSpeedIn')
        h2 
          span.green 
      eg-transition(enter='fadeInUpBig')
        h4.center
          span.red <i class="material-icons md-48">favorite_border</i>
          span.white 
      eg-transition(enter='lightSpeedIn')
        h4.center.date
          span.yellow 
          span.grey 
      eg-transition(enter='jello')
        p.yellow.center
          // span <i class="material-icons md-48">navigate_next</i>
      <br /><br />
      eg-transition(enter='fadeInUpBig')
        p.center.tiny.grey 

</template>
<script>
import eagle from 'eagle.js'
export default {
  mixins: [eagle.slideshow],
  infos: {
    title: '',
    description: '',
    path: ''
  },
	mounted () {
    setInterval(() => {
      // this.nextSlide()
    }, 7000)
    this.onEndExit = function () {
      this.currentSlideIndex = 1
    }
  },
  data () {
    return {
      image: 'http://source.unsplash.com/IKJrYtdFku8/1200',
      about_images: [
        // rivegauche.org notre dame
        'http://source.unsplash.com/EHfBqTitAs4/1200',
        'https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Notre_Dame_de_Paris_view_from_Rive_Gauche.jpg/1280px-Notre_Dame_de_Paris_view_from_Rive_Gauche.jpg',
        // omou.pw cloud
        'http://source.unsplash.com/WVYvJt6-ZFM/1200',
        // omou.pw snow
        'http://source.unsplash.com/HfDasDyQCPQ/1200',
        // Soso Zoo HB NN 20190',
        'https://lh3.googleusercontent.com/4uZCWIP-g-L8HAGRcMJFCEVzVrgpTPp-urG5fUCymd2iUBdF_mCV_ub2f2pl7CTZeqbPWqA2rxICymAr8mnikGRf70KsQeTYxDOgab8wK66wy8z6Iab7R2PcFa-XJ7w4Oe6qUGaL-E4=w2400',
        'https://lh3.googleusercontent.com/5zX9hrQyK2rxanH_Meh6QeCJg77W463AIAmGyrDnVNTJPe-fuidcu69OlzFGmmJY97o2ApdTOR73nt4jgSbvozBGVb4alA019bHq4WUUiI_1c4tN4p37c01v8E30lZg32ESibJynuKE=w2400',
        // Architecture MD.ai
        'http://source.unsplash.com/I378DhssWqU/1200',
        // Spiral architecture MD.ai
        'http://source.unsplash.com/w1g2o4J_4Dg/1200',
				// CXR lung segmentation MD.ai
        'https://www.md.ai/_nuxt/img/4431345.png',
				// Containers SIIM 2019
        'http://source.unsplash.com/uBe2mknURG4/1200',
				// Silos SIIM 2019
        'http://source.unsplash.com/0vswdLWM3qg/1200',
				// Pineapple ARRS 2019
        'http://source.unsplash.com/9Jq5UvyXr8A/1200',
        // Oculus HSS 2019
        'http://source.unsplash.com/vwYqqarlIgw/1200',
        // Snow Left Toronto 2019
        'http://source.unsplash.com/4GLNODmBST8/1200',
        'http://source.unsplash.com/GTlW1g06Kz8/1200',
        'http://source.unsplash.com/qv2A0oDJRDY/1200',
        'http://source.unsplash.com/5GwLlb-_UYk/1200',
        ''
      ],
      images: [
        '',
        ''
      ]
    }
  }
}

</script>

<style lang='scss'>
#ThemesSlideshow {
  // STYLES THAT ARE GLOBAL FOR THIS PARTICULAR SLIDESHOW

  h3 {
    font-weight: normal;
    text-transform: uppercase;
  }
  .green {
    color: lightseagreen;
  }
  .yellow {
    color: goldenrod;
  }
  .yellowgreen {
    color: yellowgreen;
  }
  .red {
    color: firebrick;
  }
  .grey {
    color: #bbb
  }
  .white {
    color: rgba(255, 255, 255, 0.75);
  }
  .eg-slide-content {
    // width: 35em;
    // max-width: 100%;
    // margin: 0 auto;
  }
  .local-eg-pic {
    position: absolute;
    top: 10;
    //left: 0;
    //max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
  }
  .smaller {
    font-size: 0.5em;
  }

  .pic {
    margin-top: 10;
    position: absolute;
    top: 10;
    //left: 0;
    //max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
  }

  // LOCAL THEMES FOR SLIDES
  .local-eg-theme-book{
    //background: url('');
    background-position: center;
    background-size: 68%;
    background-repeat: no-repeat;
  }
  .change-bg{
    background-position: top;
    background-color: rgba(17,34,51,1.0);
    background-size: 140%;
    background-repeat: no-repeat;
    -webkit-animation: backgroundScroll 3s linear infinite alternate;
    -webkit-animation-fill-mode: none;
    animation: backgroundScroll 3s linear infinite alternate;
    animation-fill-mode: none;
  }

  .local-eg-theme-book_cover-works{
    // -webkit-filter: grayscale(100%);
    @import url(https://fonts.googleapis.com/css?family=Source+Code+Pro);
    @import url(https://fonts.googleapis.com/css?family=Special+Elite);
    background-color: rgba(17,34,51,1.0);
    background: linear-gradient(rgba(17,34,51,0.5),rgba(17,34,51,0.9));
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    h4.date {
      // font-family: 'Source Code Pro';
      font-family: 'Special Elite';
      font-size: 0.8em;
    }
    p.tiny {
      font-size: 0.4em;
    }
  }

  .local-eg-theme-book_cover{
    // -webkit-filter: grayscale(100%);
    background-position: center;
    background-color: rgba(17,34,51,1.0);
    background: linear-gradient(rgba(17,34,51,0.5),rgba(17,34,51,0.9));
    background-size: cover;
    background-repeat: no-repeat;
    a { color: inherit;  }
    a:link { text-decoration: none; }
    a:hover { text-decoration: underline; }
  }

  .local-eg-theme-book_simple{
    // -webkit-filter: grayscale(100%);
    background-color: rgba(17,34,51,1.0);
    background: linear-gradient(rgba(17,34,51,0.5),rgba(17,34,51,0.9));
    // background-size: cover;
    background-size: 68%;
    background-position: center;
    background-repeat: no-repeat;
  }

  .local-eg-theme-book_nobg{
    // -webkit-filter: grayscale(100%);
    background-position: top;
    background-color: rgba(17,34,51,1.0);
    background: linear-gradient(rgba(17,34,51,0.5),rgba(17,34,51,0.9));
    background-size: 140%;
    background-repeat: no-repeat;
    -webkit-animation: backgroundScroll 9s linear infinite alternate;
    -webkit-animation-fill-mode: none;
    animation: backgroundScroll 9s linear infinite alternate;
    animation-fill-mode: none;
  }

  .local-eg-theme-book_00{
    // random from new york collection
    // background: linear-gradient(rgba(17,34,51,0.5),rgba(17,34,51,0.5)),url('https://source.unsplash.com/collection/349236/1200');
    background: linear-gradient(rgba(17,34,51,0.2),rgba(17,34,51,0.8)),url('http://source.unsplash.com/gq5PECP8pHE/1200');
    background-position: top;
    background-color: rgba(17,34,51,1.0);
    background-size: 120%;
    background-repeat: no-repeat;
    -webkit-animation: backgroundScroll 3s linear infinite alternate;
    -webkit-animation-fill-mode: none;
    animation: backgroundScroll 3s linear infinite alternate;
    animation-fill-mode: none;
  }

  @-webkit-keyframes backgroundScroll {
    from {background-position: 0 0;}
    to {background-position: -40px 0px;}
  }
  @keyframes backgroundScroll {
    from {background-position: 0 0;}
    to {background-position: -40px 0px;}
  }

  .local-eg-theme-book_01{
    // background: url('');
    // background: url('https://source.unsplash.com/collection/349236/1200');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .local-eg-theme-book_02{
    background-position: center;
    background-size: 68%;
    background-repeat: no-repeat;
  }

  .local-eg-theme-book_03{
    background-position: center;
    background-size: 68%;
    background-repeat: no-repeat;
  }

  .local-eg-theme-book_04{
    background-position: center;
    background-size: 68%;
    background-repeat: no-repeat;
  }

  .local-eg-theme-book_05{
    background-position: center;
    background-size: 68%;
    background-repeat: no-repeat;
  }

  .local-eg-theme-book_06{
    background-position: center;
    background-size: 68%;
    background-repeat: no-repeat;
  }

  .local-eg-theme-book_07{
    background-position: center;
    background-size: 68%;
    background-repeat: no-repeat;
  }

  .local-eg-theme-book_08{
    background-position: center;
    background-size: 68%;
    background-repeat: no-repeat;
  }

  .local-eg-theme-book_09{
    background-position: center;
    background-size: 68%;
    background-repeat: no-repeat;
  }

  .local-eg-theme-book_10{
    background-position: center;
    background-size: 68%;
    background-repeat: no-repeat;
  }

  .local-eg-theme-artic {
    background-color: #11a9e2;
    background-image: none;
    color: #fff;
    h1 {
      font-weight: bold;
      font-size: 3em;
    }
    h1, p {
      font-family: "Comfortaa", Helvetica, Arial, sans-serif;
      margin-top: 0;
      position: absolute;
      top:50%;
      left:50%;
      transform: translateX(-50%) translateY(-50%);
      width: 80%;

      text-shadow: 0 0.01em 0 #ccc,
                   0 0.02em 0 #c9c9c9,
                   0 0.03em 0 #bbb,
                   0 0.04em 0 #b9b9b9,
                   0 0.05em 0 #aaa,
                   0 0.06em 0.01em rgba(0,0,0,.1),
                   0 0 0.05em rgba(0,0,0,.1),
                   0 0.01em 0.03em rgba(0,0,0,.3),
                   0 0.03em 0.05em rgba(0,0,0,.2),
                   0 0.05em 0.1em rgba(0,0,0,.25),
                   0 0.1em 0.1em rgba(0,0,0,.2),
                   0 0.2em 0.2em rgba(0,0,0,.15);
    }
  }

  .local-eg-theme-foreword {
    @import url(https://fonts.googleapis.com/css?family=Open+Sans);
    @import url(https://fonts.googleapis.com/css?family=Source+Code+Pro);
    @import url(https://fonts.googleapis.com/css?family=Special+Elite);
    background: url('./assets/pw_maze_black.png') repeat;
    font-family: 'Open Sans', sans-serif;
    //font-size: 1em;
    color: #ccc;
    .grey {
      color: #bbb
    }
    .white {
      color: rgba(255, 255, 255, 0.75);
    }
    .eg-slide-content {
      // max-width: 100%;
      // width: 25em;
    }
    p {
      // margin-top: 30%;
    }
    p.tiny {
      font-size: 0.4em;
    }
    p.pubs {
      position: absolute;
      font-family: 'Source Code Pro';
      color: rgba(255, 255, 255, .8);
      font-size: 0.4em;
      top: -5%;
      left: 5%;
      right: 5%;
      // float: left;
      // max-width: 100%;
      // width: 55em;
    }
    a:link {
      color: #ccf;
      text-decoration: none;
    }
    a:hover {
        text-decoration: underline;
    }
    h4.smaller {
      font-size: 0.8em;
    }
  }

  .local-eg-theme-bretagne {
    @import url(https://fonts.googleapis.com/css?family=Pompiere);
    h3 {
      // letter-spacing: 1px;
      font-family: 'Pompiere';
      text-transform: none;
      font-size: 3em;
      color: rgba(255, 255, 255, .6);
    }
    background-image: url(https://i.imgur.com/rYkJ6I8.jpg);
    background-position: center;
    background-size: cover;
  }
  .local-eg-theme-forest-road {
    @import url(https://fonts.googleapis.com/css?family=Cabin+Sketch);
    h3 {
      font-family: 'Cabin Sketch';
      margin-top: 50%;
      text-align: left;
      color: rgba(255, 255, 255, .9);
    }
    background-image: url(https://i.imgur.com/hxTMFZW.jpg);
    background-position: center;
    background-size: cover;

  }

  .local-eg-theme-spark {
    @import url(https://fonts.googleapis.com/css?family=Special+Elite);
    h3 {
      position: absolute;
      font-family: 'Special Elite';
      color: rgba(255, 255, 255, .8);
      font-size: 1em;
      bottom: 10%;
      float: left;
    }
    background-image: url(https://i.imgur.com/FL9mwpd.jpg);
    background-position: center;
    background-size: cover;
  }
  .local-eg-theme-city {
    @import url(https://fonts.googleapis.com/css?family=Patrick+Hand+SC);
    // @import './assets/monokai';
    .eg-code-block {
      margin-top: 30%;
    }
    .code-box {
      box-shadow: 0 0 0.25em 0.25em #ddd
    }
    background-image: url(https://i.imgur.com/kmmHith.jpg);
    background-position: center;
    background-size: cover;
  }
  .local-eg-theme-space {
    @import url(https://fonts.googleapis.com/css?family=Cabin+Sketch);
    h1 {
      font-family: 'Cabin Sketch';
      font-size: 2.5em;
      color: rgba(255, 255, 255, 0.75);
      letter-spacing: 1.5px;
      margin-top: 20%
    }
    background-image: url(https://i.imgur.com/yO2ivoD.jpg);
    background-position: center;
    background-size: cover;
  }

  .material-icons.md-18 { font-size: 18px;  }
  .material-icons.md-24 { font-size: 24px;  }
  .material-icons.md-36 { font-size: 36px;  }
  .material-icons.md-48 { font-size: 48px;  }
}

</style>
